import { gql } from "@apollo/client"

// Solo la primera sesion que reclama la orden recibe true, asi el ticket se imprime una sola vez
export const RECLAMAR_IMPRESION_ORDEN = gql`
    mutation ReclamarImpresionOrden($hotel_id: ID!, $orden_key: ID!) {
        reclamar_impresion_orden(hotel_id: $hotel_id, orden_key: $orden_key)
    }
`
